module.exports = __webpack_public_path__ + "static/green-yoga-a1d9e546c963873efcb36dce0a120a78.webm";